const one = 'א';
const two = 'ב';
const three = 'ג';
const four = 'ד';
const five = 'ה';
const six = 'ו';
const seven = 'ז';
const eight = 'ח';
const nine = 'ט';
const ten = 'י';
const twenty = 'כ';
const thirty = 'ל';
const forty = 'מ';
const fifty = 'נ';
const sixty = 'ס';
const seventy = 'ע';
const eighty = 'פ';
const ninety = 'צ';
const oneHundred = 'ק';
const twoHundred = 'ר';
const threeHundred = 'ש';
const fourHundred = 'ת';
const fiveHundred = fourHundred + oneHundred;
const sixHundred = fourHundred + twoHundred;
const sevenHundred = fourHundred + threeHundred;
const eightHundred = fourHundred + fourHundred;
const nineHundred = fourHundred + fourHundred + oneHundred;

const ones = [one, two, three, four, five, six, seven, eight, nine];
const tens = [ten, twenty, thirty, forty, fifty, sixty, seventy, eighty, ninety];
const hundreds = [
    oneHundred,
    twoHundred,
    threeHundred,
    fourHundred,
    fiveHundred,
    sixHundred,
    sevenHundred,
    eightHundred,
    nineHundred,
];

const gershayim = '"';

export default function convertNumberToHebrew(
    inputNumber: number,
    hideNumberIndicator?: boolean
): string {
    // Thousands are ignored
    inputNumber = inputNumber % 1000;

    const hundredsDigit = Math.floor(inputNumber / 100);
    const hundredsValue = hundredsDigit > 0 ? hundreds[hundredsDigit - 1] : '';

    inputNumber = inputNumber % 100;

    let tensValue = '';
    let onesValue = '';

    // There are special cases for 15 and 16, which use 9 + 6 and 9 + 7, respectively
    if (inputNumber === 15) {
        tensValue = nine;
        onesValue = six;
    } else if (inputNumber === 16) {
        tensValue = nine;
        onesValue = seven;
    } else {
        const tensDigit = Math.floor(inputNumber / 10);
        tensValue = tensDigit > 0 ? tens[tensDigit - 1] : '';

        inputNumber = inputNumber % 10;

        const onesDigit = inputNumber;
        onesValue = onesDigit > 0 ? ones[onesDigit - 1] : '';
    }

    // Note that Hebrew is an RTL language, but we are returning it as if it was LTR.  This is because the
    // UI is actually smart and will display the string appropriately
    let result = hundredsValue + tensValue + onesValue;

    // If there are two or more digits, inset a gershayim (similar to a double quote) right before the least
    // significant digit.  This is used to indicate that a value is a number and not a word.  We provide the
    // option to suppress this character because it is not shown in certain cases e.g. the day of the month
    if (result.length >= 2 && !hideNumberIndicator) {
        result = result.slice(0, result.length - 1) + gershayim + result.slice(result.length - 1);
    }

    return result;
}
